import ProductTitle from '../../js/lib/product-title';
import Image from '../../js/utils/image';

export default (item, config) => {
  const getDetail = () => {
    const { color, detail } = item;
    let markup = '';

    if (detail) {
      markup = `<span class="p-[6px] font-sans text-[9px] leading-none uppercase font-bold bg-grey-700 text-white whitespace-nowrap">${item.detail}</span>`;
    } else if (color) {
      markup = `<p class="text-sm capitalize text-grey-400 empty:hidden">${color}</p>`;
    }

    return markup;
  };

  const getDiscountString = () => {
    const beforePrice = item.compare_at_price;
    if (beforePrice && beforePrice > item.price) {
      let discount = Math.floor(((beforePrice - item.price) / beforePrice) * 100);
      if (discount == 0) discount = 1;

      const discountString = config.discountType === 'percent' ? `-${discount}%` : `-${Shopify.formatMoney(discount)}`;
      return discountString;
    }

    return '';
  };

  const getBeforePrice = () => {
    const beforePrice = item.compare_at_price;
    if (beforePrice && beforePrice > item.price)  return Shopify.formatMoney(beforePrice, window.theme.moneyFormat);
    else return '';
  };

  const getPrice = () => {
    const discount = 0;
    let price;

    if (config.discountType === 'percent') {
      price = item.price - ((item.price / 100) * discount);
    } else if (config.discountType === 'cents') {
      price = item.price - discount;
    }

    return Shopify.formatMoney(price, window.theme.moneyFormat);
  };

  const getPriceInfo = () => {
    if (item.available) {
      return `<p class="text-brand empty:hidden">${getDiscountString()}</p>
        <p class="text-grey-400 line-through empty:hidden">${getBeforePrice()}</p>
        <p class="text-xs">${getPrice()}</p>`;
    }
    return '';
  };

  const getBtn = () => {
    if (item.available) {
      return window.theme.templates.upsellItemAddBtn;
    }
    return `<a href="${item.url}" class="button button--small button--outlined-dark">
        ${window.theme.strings.cart.upsell.signUp}
      </a>`;
  };

  function getItemLengthValue(itemLength) {
    if (itemLength !== null && itemLength !== "Standard") {
      return `<span class="upsell_item__size font-medium text-white px-2 py-1 rounded-sm bg-grey-400 ml-2 lg:ml-4">${itemLength}</span>`
    } else {
      return ''
    }
  }

  function getSize(itemSize) {
    return getItemLengthValue(item.length) ? `${itemSize}` : itemSize;
  }

  return window.theme.templates.upsellItem
    .replace('%variantId%', item.id)
    .replaceAll('%url%', item.url)
    .replace('%img%', Image(item.image))
    .replaceAll('%title%', item.productTitle)
    .replace('%productTitle%', ProductTitle(item.productTitle))
    .replace('%detail%', getDetail())
    .replace('%fit%', item.fit)
    .replace('%size%', getSize(item.size))
    .replace('%length%', getItemLengthValue(item.length))
    .replace('%priceInfo%', getPriceInfo())
    .replace('%button%', getBtn());
};
